module.exports = __webpack_public_path__ + "img/home-allubum.0b84a39f.webp";